'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Helpers = require('common/Helpers');

var dom = {
  hover: 'data-pass-hover-to',
  getHover: 'data-get-hover-from',
  desktopLink: 'data-desktop-only'
};

var setupHover = function setupHover() {
  var hoverElements = document.querySelectorAll('[' + dom.hover + ']');
  hoverElements.forEach(function (element) {
    var sendToID = element.getAttribute(dom.hover);
    var sendTo = document.querySelector('[' + dom.getHover + '="' + sendToID + '"]');
    // Pass the mouse over to the reciever
    element.addEventListener('mouseover', function (event) {
      sendTo.classList.add('hover');
    });
    // Pass mouse leave to the reciever
    element.addEventListener('mouseleave', function (event) {
      sendTo.classList.remove('hover');
    });
  });
};

var handleDesktopClick = function handleDesktopClick(event) {
  if ((0, _Helpers.isMobileDevice)()) {
    event.preventDefault();
  }
};

var setupClicks = function setupClicks() {
  var desktopLinks = document.querySelectorAll('[' + dom.desktopLink + ']');
  desktopLinks.forEach(function (link) {
    link.addEventListener('click', handleDesktopClick);
  });
};

var setup = function setup(eventType) {
  eventType == 'hover' && setupHover();
  setupClicks();
};

exports.default = {
  setup: setup
};